// Element.matches polyfill
try {
  const eProto = Element.prototype;
  if (!eProto.matches) {
    eProto.matches =
      eProto.matchesSelector || eProto.webkitMatchesSelector || eProto.mozMatchesSelector || eProto.msMatchesSelector;

    console.log('[Polyfills] Element.matches polyfill added.');
  }
} catch (error) {
  console.error('[Polyfills] Unable to polyfill Element.matches', error);
}
